
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';

interface Brand {
  id: number;
  brand: string;
  initial: string;
  country: string;
}
@Component
export default class VehicleModule extends Vue {
  BrandLetters = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];
  backIndex = 0;

  backArr = ['A', 'B', 'C'];

  current = '2';

  visible = false;

  selectedBrand: any = '';

  brandID: any = '';

  brandObj: any = {};

  groupedByInitial: Record<string, Brand[]> = {};

  vehicleData: any = [];

  seriesObj: any = {};

  modelData: any = [];

  modelObj: any = {};

  @Prop()
  form!: any;

  @lazyInject(CarService)
  private carService!: CarService;

  async init() {
    this.visible = true;

    const res: Brand[] = await this.carService.getCarBrandList();
    // 按 initial 字段聚合
    const groupedByInitial = res.reduce<Record<string, Brand[]>>(
      (acc, brand) => {
        const key = brand.initial ? brand.initial.charAt(0).toUpperCase() : '#';

        // 判断 key 是否为字母 A-Z
        const isLetter = /^[A-Z]$/i.test(key);

        const groupKey = isLetter ? key.toUpperCase() : '#';

        if (!acc[groupKey]) {
          acc[groupKey] = [];
        }
        acc[groupKey].push(brand);
        return acc;
      },
      {},
    );
    this.groupedByInitial = groupedByInitial;
    const {
      brandName,
      modelName,
      seriesName,
      brand_id,
      series_id,
      model_id,
      gearName,
      liter,
      vehicleSourcePriceInformation,
    } = this.form;
    if (brand_id) {
      this.brandObj = {
        brand: brandName,
        brandID: brand_id,
      };
      this.brandID = brand_id;
      const data: any = {
        id: brand_id,
        brand: brandName,
      };
      this.selectBrand(data, false);
    }
    if (series_id) {
      this.seriesObj = {
        series: seriesName,
        seriesId: series_id,
      };
      const data = {
        id: series_id,
        series: seriesName,
      };
      this.selectSeries(data, false);
    }
    if (model_id) {
      this.modelObj = {
        modelName,
        modelId: model_id,
        gearName,
        liter,
        official_price: vehicleSourcePriceInformation.officialPrice,
      };
    }
  }

  close() {
    this.visible = false;
  }

  submit() {
    const _Object = {
      ...this.brandObj,
      ...this.seriesObj,
      ...this.modelObj,
    };
    this.visible = false;
    console.log(_Object);
    this.$emit('updateName', _Object);
  }

  callback(key: string) {
    this.current = key;
  }

  getClass(index: number) {
    if (this.backIndex === 0) {
      if (index === 0) {
        return 'brand_letter_active';
      } else if (index === 1) {
        return 'brand_letter_center';
      } else if (index === 2) {
        return 'brand_letter_after';
      } else {
        return 'brand_letter';
      }
    } else if (this.backIndex === this.BrandLetters.length - 1) {
      if (index === this.BrandLetters.length - 3) {
        return 'brand_letter_active';
      } else if (index === this.BrandLetters.length - 2) {
        return 'brand_letter_center';
      } else if (index === this.BrandLetters.length - 1) {
        return 'brand_letter_after';
      } else {
        return 'brand_letter';
      }
    } else if (index === this.backIndex - 1) {
      return 'brand_letter_active';
    } else if (index === this.backIndex) {
      return 'brand_letter_center';
    } else if (index === this.backIndex + 1) {
      return 'brand_letter_after';
    } else {
      return 'brand_letter';
    }
  }

  changeBrand(letter: string) {
    const _index = this.BrandLetters.indexOf(letter);
    this.backIndex = _index;
    this.selectedBrand = letter;
    const Arr = [];
    if (_index === 0) {
      Arr[0] = letter;
      Arr[1] = this.BrandLetters[1];
      Arr[2] = this.BrandLetters[2];
    } else if (_index === this.BrandLetters.length - 1) {
      Arr[0] = this.BrandLetters[this.BrandLetters.length - 3];
      Arr[1] = this.BrandLetters[this.BrandLetters.length - 2];
      Arr[2] = letter;
    } else {
      Arr[0] = this.BrandLetters[_index - 1];
      Arr[1] = letter;
      Arr[2] = this.BrandLetters[_index + 1];
    }
    // console.log(Arr);
    this.backArr = Arr;
  }

  async selectBrand(item: Brand, type?: boolean) {
    this.brandID = item.id;
    const { id, brand } = item;
    this.brandObj.brand = brand;
    this.brandObj.brandId = id;
    this.seriesObj = {};
    this.modelObj = {};
    const res = await this.carService.getCarModelList(item.id);
    const Vehicle = this.groupByManufacturer(res);
    this.vehicleData = Vehicle;
    if (type) {
      this.current = '3';
    }
  }

  async selectSeries(item: any, type?: boolean) {
    this.seriesObj.seriesId = item.id;
    this.seriesObj.series = item.series;
    this.modelObj = {};
    const res = await this.carService.getCarModelDetail(item.id);
    const model = this.groupByModelName(res);
    this.modelData = model;
    if (type) {
      this.current = '4';
    }
  }

  selectModel(item: any) {
    this.modelObj = {};
    this.modelObj.modelId = item.id;
    this.modelObj.modelName = item.model_name;
    this.modelObj.gearName = item.gear_name;
    this.modelObj.liter = item.liter;
    this.modelObj.official_price = item.official_price
      ? Number(item.official_price) / 10000
      : 0;
  }

  groupByManufacturer(data: any) {
    const map: any = {};
    const result: any[] = [];

    data.forEach((item: any) => {
      const key = item.manufacturer_id;

      if (!map[key]) {
        map[key] = {
          manufacturer_id: item.manufacturer_id,
          manufacturer: item.manufacturer,
          children: [],
        };
        result.push(map[key]);
      }

      map[key].children.push({
        id: item.id,
        series: item.series,
      });
    });

    return result;
  }
  groupByModelName(data: any) {
    const map: any = {};
    const result: any[] = [];

    data.forEach((item: any) => {
      const key = item.year;

      if (!map[key]) {
        map[key] = {
          model_name: item.model_name,
          model_year: item.model_year,
          official_price: item.official_price,
          discharge_standard: item.discharge_standard,
          liter: item.liter,
          gear_name: item.gear_name,
          year: item.year,
          children: [],
        };
        result.push(map[key]);
      }

      map[key].children.push({
        id: item.id,
        model_name: item.model_name,
        model_year: item.model_year,
        official_price: item.official_price,
        discharge_standard: item.discharge_standard,
        liter: item.liter,
        gear_name: item.gear_name,
        year: item.year,
      });
    });

    return result;
  }
}
